import { throttle } from '../general/helpers';
export class Tabs {
  constructor(options) {
    const defaultOptions = {
      wrapperCssSelector: '.spy-tabs__wrapper',
      controlCssSelector: '.spy-tabs__btn',
      contentCssSelector: '.spy-tabs__item',
      dataAttrConnect: 'data-tab',
      activeCssClass: '_active',
      afterInitCallback: null,
      afterSwitchTabCallback: null,
    };
    this.options = Object.assign(defaultOptions, options);
    this.collectionContent = document
      .querySelector(this.options.wrapperCssSelector)
      .querySelectorAll(this.options.contentCssSelector);
    this.collectionControl = document
      .querySelector(this.options.wrapperCssSelector)
      .querySelectorAll(this.options.controlCssSelector);
    this.activeTabControl = null;
    this.activeTabContent = null;
    this.contentObj = {};
    this.recalculatePointOnResize = this.recalculatePointOnResize.bind(this);
  }

  init() {
    if (
      this.isElementPresent(document.querySelector(this.options.wrapperCssSelector), true)
    ) {
      this.createObjFromTabs();
      this.setActiveTabOnInit();
      this.addEventListenerOnControl();
      this.recalculatePointOnResize();
    }
  }

  createObjFromTabs = () => {
    for (let index = 0; index < this.collectionContent.length; index++) {
      const element = this.collectionContent[index];
      this.contentObj[element.getAttribute(this.options.dataAttrConnect)] = element;
    }
  };
  isElementPresent = (element, single = false) => {
    if (single) {
      return element !== null && element !== undefined ? true : false;
    } else {
      return element.length > 0 ? true : false;
    }
  };
  setActiveTabOnInit = () => {
    const activeControl = this.collectionControl[0];
    this.activeTabControl = activeControl;
    activeControl.classList.add(this.options.activeCssClass);
    const activeTab =
      this.contentObj[activeControl.getAttribute(this.options.dataAttrConnect)];
    this.activeTabContent = activeTab;
    activeTab.classList.add(this.options.activeCssClass);
    this.spyTabs(activeControl);
  };
  addEventListenerOnControl = () => {
    for (let index = 0; index < this.collectionControl.length; index++) {
      const element = this.collectionControl[index];
      element.addEventListener('click', () => {
        this.swicthTab(element);
      });
    }
  };
  swicthTab = (element) => {
    this.activeTabControl.classList.remove(this.options.activeCssClass);
    this.activeTabContent.classList.remove(this.options.activeCssClass);
    this.activeTabControl = element;
    element.classList.add(this.options.activeCssClass);
    const activeTab = this.contentObj[element.getAttribute(this.options.dataAttrConnect)];
    this.activeTabContent = activeTab;
    activeTab.classList.add(this.options.activeCssClass);
    this.spyTabs(element);
  };
  spyTabs = () => {
    const point = document.querySelector('.spy-tabs__point');
    const controlWrapper = document.querySelector('.spy-tabs__control');
    const activeBtnOffset = this.activeTabControl.getBoundingClientRect().top;
    const controlWrapperOffset = controlWrapper.getBoundingClientRect().top;
    const top =
      activeBtnOffset -
      controlWrapperOffset +
      this.activeTabControl.clientHeight / 2 -
      point.clientHeight / 2;

    point.style.cssText = `top: ${top}px`;
  };
  recalculatePointOnResize = () => {
    window.addEventListener('resize', throttle(this.spyTabs, 800));
  };
}
